import script from "./productOptionModify.vue?vue&type=script&setup=true&lang=js"
export * from "./productOptionModify.vue?vue&type=script&setup=true&lang=js"

import "./productOptionModify.vue?vue&type=style&index=0&id=1a5dd664&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a5dd664"]])

export default __exports__